import React, { useEffect, useMemo, useState } from 'react'
import { Card, CardBody, CardHeader, Col, Container, Row, Spinner, Label, Input, Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import TableContainer from '../../Components/Common/TableContainerReactTable';
import useObtenerClientes from '../../Components/Hooks/useObtenerClientes';
import useCreateCliente from '../../Components/Hooks/useCreateCliente';
import useDeleteCliente from '../../Components/Hooks/useDeleteCliente';
import ModalModificarCliente from '../../Components/modals/ModalModificarCliente';
import ModalLeerCliente from '../../Components/modals/ModalLeerCliente';

const Clientes = () => {

    const [limit, setLimit] = useState(100);
    const [clienteSeleccionado, setClienteSeleccionado] = useState('');
    const [refresh, setRefresh] = useState(0);
    const { clientes, loading, error } = useObtenerClientes(limit, refresh);
    const [modalCrearOpen, setModalCrearOpen] = useState(false);
    const [modalModificarOpen, setModalModificarOpen] = useState(false);
    const [modalLeerOpen, setModalLeerOpen] = useState(false);
    const { createCliente, loading: createLoading, error: createError } = useCreateCliente();
    const { deleteCliente, loading: deleteLoading, error: deleteError } = useDeleteCliente();
    const [modalEliminarOpen, setModalEliminarOpen] = useState(false);

    useEffect(() => {
        document.title = "Clientes | Siga ERP";
    }, []);

    const columns = useMemo(
        () => [
            {
                header: "RUT",
                accessorKey: "CLIPRO",
                enableColumnFilter: false,
            },
            {
                header: "Tipo persona",
                accessorKey: "TIPPRO",
                enableColumnFilter: false
            },
            {
                header: "Nombre",
                accessorKey: "RAZSOC",
                enableColumnFilter: false,
                cell: ({ row }) => row.original.RAZSOC || row.original.APENOM || 'N/A'
            },
            {
                header: "Email",
                accessorKey: "CEMAIL",
                enableColumnFilter: false,
            },
            {
                header: "Teléfono",
                accessorKey: "NFONO1",
                enableColumnFilter: false,
            },
            {
                header: "Dirección",
                accessorKey: "DIRECC",
                enableColumnFilter: false,
            },
            {
                header: "Ciudad",
                accessorKey: "CIUDAD",
                enableColumnFilter: false,
            },
            {
                header: "Comuna",
                accessorKey: "COMUNA",
                enableColumnFilter: false,
            },
        ],
        []
    );

    const handleCellClick = (cellInfo) => {
        console.log('Celda clickeada:', cellInfo);
        console.log('Columna:', cellInfo.columnId);
        console.log('Valor:', cellInfo.value);
        console.log('Datos completos de la fila:', cellInfo.rowData);
        setClienteSeleccionado(cellInfo.rowData.CLIPRO);
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Row>
                        <Col lg={12}>
                            <Card>
                                <CardHeader className="d-flex justify-content-between align-items-center">
                                    <h5 className="card-title mb-0">Clientes</h5>
                                    <div className="mt-0">
                                        <Input
                                            type="text"
                                            value={clienteSeleccionado}
                                            onChange={(e) => setClienteSeleccionado(e.target.value)}
                                            style={{ width: '250px' }}
                                        />
                                    </div>
                                    <div className="d-flex align-items-center">
                                        <Button color="info" className="me-2" onClick={() => { if (clienteSeleccionado) setModalLeerOpen(true); }} disabled={!clienteSeleccionado}>
                                            <i className="ri-eye-line me-1"></i>Leer
                                        </Button>
                                        <Button color="warning" className="me-2" onClick={() => { if (clienteSeleccionado) setModalModificarOpen(true) }} disabled={!clienteSeleccionado}>
                                            <i className="ri-edit-line me-1"></i>Modificar
                                        </Button>
                                        <Button color="primary" className="me-2" onClick={() => setModalCrearOpen(true)} disabled={createLoading}>
                                            <i className="ri-add-line me-1"></i>Crear
                                        </Button>
                                        <Button color="danger" className="me-2" onClick={() => {
                                            if (clienteSeleccionado) {
                                                setModalEliminarOpen(true);
                                            }
                                        }} disabled={!clienteSeleccionado || deleteLoading}>
                                            <i className="ri-delete-bin-line me-1"></i>Eliminar
                                        </Button>
                                        <Label className="form-label mb-0 me-2">Límite</Label>
                                        <div className="mt-0">
                                            <Input
                                                type="number"
                                                min={1}
                                                value={limit}
                                                onChange={(e) => setLimit(e.target.value)}
                                                style={{ width: '100px' }}
                                            />
                                        </div>
                                    </div>
                                </CardHeader>
                                <CardBody>
                                    {error ? <div className="alert alert-danger">{error}</div> : loading ? <div className="text-center"><Spinner animation="border" variant="primary" /></div> : <TableContainer
                                        columns={(columns || [])}
                                        data={clientes || []}
                                        customPageSize={15}
                                        isGlobalFilter={true}
                                        SearchPlaceholder='Buscar...'
                                        onCellClick={handleCellClick}
                                    />}
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
           
            <ModalModificarCliente
                isOpen={modalModificarOpen}
                toggle={() => setModalModificarOpen(false)}
                onSave={() => {
                    setRefresh(prev => prev + 1); // Refresh the table
                }}
                selectedCliente={clienteSeleccionado}
            />
            <ModalLeerCliente
                isOpen={modalLeerOpen}
                toggle={() => setModalLeerOpen(false)}
                selectedCliente={clienteSeleccionado}
            />
            <Modal isOpen={modalEliminarOpen} toggle={() => setModalEliminarOpen(false)} centered>
                <ModalHeader toggle={() => setModalEliminarOpen(false)}>Confirmar Eliminación</ModalHeader>
                <ModalBody>
                    <p>¿Está seguro que desea eliminar el cliente <strong>{clienteSeleccionado}</strong>?</p>
                    <p className="text-muted mb-0">Esta acción no se puede deshacer.</p>
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={() => setModalEliminarOpen(false)}>
                        Cancelar
                    </Button>
                    <Button color="danger" onClick={async () => {
                        const result = await deleteCliente(clienteSeleccionado);
                        if (result.success) {
                            toast.success('Cliente eliminado exitosamente');
                            setModalEliminarOpen(false);
                            setClienteSeleccionado('');
                            setRefresh(prev => prev + 1);
                        } else {
                            const err = result.error || '';
                            if (err.includes('409') || err.toLowerCase().includes('conflict') || err.toLowerCase().includes('related')) {
                                toast.error('No se puede eliminar el cliente porque tiene registros relacionados');
                            } else {
                                toast.error('Error al eliminar cliente: ' + err);
                            }
                        }
                    }} disabled={deleteLoading}>
                        {deleteLoading ? <Spinner size="sm" /> : <><i className="ri-delete-bin-line me-1"></i>Eliminar</>}
                    </Button>
                </ModalFooter>
            </Modal>
            <ToastContainer />
        </React.Fragment>
    )
}

export default Clientes;